import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const TechnologySkillsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(10 27) rotate(-19.93)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(108 15) rotate(0.23)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(198 15) rotate(3.23)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(10 110) rotate(-19.93)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(110 90) rotate(4.87)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(200 90) rotate(4.87)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-technology-skills"
      transform="translate(1037, 497)"
    >
      <defs>
        <linearGradient
          id="ed76f39f-d841-4520-93b6-3788650c65c6"
          data-name="grad-48-qwdqw"
          x1="449.02"
          y1="182.31"
          x2="449.33"
          y2="220.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f9cb42" />
          <stop offset="1" stopColor="#11686b" />
        </linearGradient>
        <linearGradient
          id="a244d05f-3b31-4c8d-90db-2c878f7bc875"
          x1="446.58"
          y1="194.71"
          x2="446.75"
          y2="215.72"
          xlinkHref="#ed76f39f-d841-4520-93b6-3788650c65c6"
        />
        <linearGradient
          id="a70b2897-6545-4a47-88ba-61d2322cc695"
          x1="449.12"
          y1="199.79"
          x2="448.38"
          y2="227.4"
          xlinkHref="#ed76f39f-d841-4520-93b6-3788650c65c6"
        />
      </defs>
      <g
        id="e5bf02f2-888d-4a7b-8911-a2d570fa848e"
        data-name="technology skills"
      >
        <g>
          <path d="M384.34,273.08l.09,0-.06,0Z" fill="#5a9e94" />
          <path d="M384.44,273.12l.05,0h0Z" fill="#5a9e94" />
          <path
            d="M461.06,273H384.18l.15.08-.24-.08H196.67a93.6,93.6,0,0,0-12.23-22.42q-3-4.07-6.31-7.88-3.65-4.19-7.7-8.09C121.58,187.44,32.83,169.56,30.07,169l32,2.16.24,0,13.21.89h0l2.48.17L96,173.46l66.21,4.48,26.9,1.82,15.53,1.05,29.66,2,54.12,3.66,8.35.57h0l38.74,2.62,69.07,4.67s5.92,7.32,14.34,18.32C431.22,228.72,448.84,252.63,461.06,273Z"
            fill="#5a9e94"
          />
          <path d="M383.68,272.85a3.27,3.27,0,0,1,.41.15H384Z" fill="#3dd87c" />
          <path
            d="M384.09,273h.09l.26.12C384.65,273.21,384.36,273.1,384.09,273Z"
            fill="#3dd87c"
          />
          <path
            d="M495,180.25l-.22,93H494s-11.86,0-32.59.31c-.11-.18-.21-.36-.32-.53H384.18c-19.4-8.53-39.18-17.74-58.8-25a198.29,198.29,0,0,0-43.93-10.67c-6.73-.87-13.43-1.4-20.09-1.67-27.44-1.12-54.19,2.3-79.38,6.41-1.29.2-2.57.41-3.85.63-8.63,1.43-17.06,2.93-25.26,4.32-29.5,5-78.09-13.9-112.56-36.46C14.56,193.71-3.31,174.81.52,162.33l.18-.56c.15-.51.32-1,.49-1.52,9.17-27.54,27.58-35.66,91.71-47.06,5.92-1,17.68-5.8,30.57-10.81,18.13-7,38.5-14.58,48.12-13.1l1.88.3c36.75,6.07,77.91,26.11,114.34,30.94a99.88,99.88,0,0,0,24.9.48h0c12.29-1.45,23.66-5.83,33.68-14.58.22-.18.43-.37.64-.56,20.68-18.45,37.6-24.23,52.4-23.84,25.84.67,45.26,20.13,67.09,23.84,0,0,5.22,11.55,12.09,29,2.08,5.26,4.32,11.07,6.6,17.24,2.95,8,6,16.58,8.9,25.48h0l.06.16h0C494.45,178.55,494.73,179.4,495,180.25Z"
            fill="#3dd87c"
          />
          <path
            d="M412.92,273c-9.15-2.26-18.19-5-27.14-7.88S368,259.1,359.1,256s-17.67-6.13-26.5-9L326,245l-3.31-1-3.28-1c-4.38-1.23-8.79-2.3-13.23-3.27a230,230,0,0,0-26.9-4q-13.56-1.19-27.25-1c-4.56.08-9.12.2-13.69.42s-9.13.56-13.7,1q-13.73,1.17-27.48,3.09c-9.17,1.2-18.37,2.62-27.61,4l-13.92,2.07c-.6.09-1.1.18-1.79.26l-2,.24c-1.33.18-2.63.23-3.95.32a74.25,74.25,0,0,1-7.75,0,118,118,0,0,1-15-1.67,145.09,145.09,0,0,1-14.36-3.23q-7-1.94-13.89-4.31t-13.48-5.2a262.21,262.21,0,0,1-25.83-12.59A236.5,236.5,0,0,1,33.4,203.69a140.75,140.75,0,0,1-21.58-19A57.59,57.59,0,0,1,3.36,173,24.64,24.64,0,0,1,.9,166.1a12.16,12.16,0,0,1,.61-7.1,17.27,17.27,0,0,0-.23,1.74,8.31,8.31,0,0,0,.09,1.72,14.73,14.73,0,0,0,.8,3.3,22.85,22.85,0,0,0,3.36,5.87c.65.92,1.41,1.78,2.13,2.65S9.18,176,10,176.75q2.43,2.42,5.07,4.61a159.24,159.24,0,0,0,22.82,15.4,301.72,301.72,0,0,0,50.24,22.55,245.17,245.17,0,0,0,26.2,7.46,132,132,0,0,0,26.2,3.36c2.13,0,4.24,0,6.29-.21,1-.1,2.07-.14,3-.31l1.49-.21c.48-.06,1.13-.19,1.68-.28l13.85-2.36c9.27-1.52,18.59-3,28-4.31s18.89-2.28,28.43-3,19.15-1,28.78-.75a226.26,226.26,0,0,1,57.25,8.21c4.67,1.3,9.26,2.84,13.8,4.5l3.39,1.27,3.31,1.32c2.22.85,4.4,1.8,6.59,2.71,8.74,3.67,17.3,7.65,25.79,11.69C379.2,256.57,395.85,265.05,412.92,273Z"
            fill="#dcf9f7"
          />
          <path
            d="M400.47,135.74c-24.94-2.7-60.07-19.27-101.28,4.09S195,122.1,147.23,127.49s-85.66,12.59-92.17,26.07,73.2,43.14,110.61,39.09,81.33-9.88,125.25.45,88.92,29.21,123.62,21.12S400.47,135.74,400.47,135.74Z"
            fill="#3db57c"
          />
          <g>
            <path
              d="M421.05,217.26s13,14.42,52.11,4.36a4.5,4.5,0,0,0,2.4-7.24C464,201.21,412.09,207,421.05,217.26Z"
              fill="#531063"
              opacity="0.47"
            />
            <g>
              <path
                d="M475.15,216.84a3.52,3.52,0,0,0,1.09-6.62,12.74,12.74,0,0,0-10.47-.66c10.31-4.42,15.59-9.82,8.84-14.72-5.4-3.93-13.75,10.3-15.71,10.3s1-5.89,5.4-11.29,3.93-9.81.49-11.29-9.33,1-10.8,16.2c0-2.45,1-17.67-2.94-16.2s-6.87,9.82-.49,18.66c-3.93,1.47-3.44-2.46-3.44-2.46s-2-14.72-8.83-11.78-4.91,10.8,0,15.71,4.9,7.85-1.48,4.91-9.32-9.82-15.21-2.95,10.3,15.22,19.63,15.71C448,220.71,465.84,218.23,475.15,216.84Z"
                fill="url(#ed76f39f-d841-4520-93b6-3788650c65c6)"
              />
              <path
                d="M469.22,215.51c.34-2.79-4.89-5.58-9.07-2.09,6.28-5.58,7.67-10.11,4.53-10.11s-10.11,5.93-11.5,5.93,3.07-2.72,6.21-6.55,1.46-6.81-1-7.85-9.23,1.22-11,10.34a1.6,1.6,0,0,1-1.09,1.21c-.54.17-1.15-1.25-1.15-1.25s-3.14-11.94-8-9.85-3.49,7.67,0,11.16,3.48,5.58-1.05,3.48-6.62-7-10.81-2.09,4.88,7.32,11.51,7.67S469.22,215.51,469.22,215.51Z"
                fill="url(#a244d05f-3b31-4c8d-90db-2c878f7bc875)"
              />
              <path
                d="M457,219.42c-1.31-.47,3.82-1.51,8.07-4s3.68-5.91,1.74-7.72-9.1-2-13.87,6a1.61,1.61,0,0,1-1.43.77c-.57,0-.66-1.56-.66-1.56s1.09-12.31-4.21-12-5.88,6-3.78,10.5,1.39,6.43-2.17,2.92-3.87-8.8-9.46-5.63,2.11,8.55,8.23,11.12S458.35,219.9,457,219.42Z"
                fill="url(#a70b2897-6545-4a47-88ba-61d2322cc695)"
              />
            </g>
          </g>
        </g>
        <g>
          <ellipse cx="80.25" cy="168.09" rx="19.21" ry="9.36" fill="#367f4b" />
          <path
            d="M86.22,167c0,3.17-6.32,5.74-14.12,5.74S58,170.21,58,167c0-.66.05-2.58.05-2.58s7.89-3.16,14.07-3.16,14.08,3.11,14.08,3.11S86.22,166.35,86.22,167Z"
            fill="#98baf5"
          />
          <ellipse cx="72.1" cy="164.64" rx="14.12" ry="5.74" fill="#b0dff6" />
          <path
            d="M71.64,163.21c1.16,1,11.58-2.3,11.58-2.3s-3.9-1.33-4.6-1.49a44,44,0,0,0-8.14,2.29Z"
            fill="#90a3f4"
          />
          <path
            d="M72.28,163.81H70V19.86L72.09,0,74.2,19.86V162.05A1.85,1.85,0,0,1,72.28,163.81Z"
            fill="#b0dff6"
          />
          <path
            d="M72.09,0l-1,9.14L72.28,20V163.81h0a1.85,1.85,0,0,0,1.92-1.76V19.86Z"
            fill="#98baf5"
          />
          <path
            d="M103.29,44.44,41,54.79a1.59,1.59,0,0,1-1.85-1.18L39,53.23a1.48,1.48,0,0,1,1.28-1.7l62.35-10.35a1.59,1.59,0,0,1,1.85,1.18l.07.38A1.48,1.48,0,0,1,103.29,44.44Z"
            fill="#b0dff6"
          />
          <path
            d="M49,53.49s6,12.14,7.22,19.87-5.4,28.12,0,43,29.45,25.37,29.45,25.37l12.61-20.41L130.08,128s-16.22-11-18.63-25.92,0-33.65-3-41.92-10.23-14.9-10.23-14.9Z"
            fill="#faf13a"
          />
          <path
            d="M48.65,50.14A2.13,2.13,0,0,1,49,53.5c6.85-1.11,16.83-2.76,16.83-2.76a2,2,0,0,0-.6-3.31C59.67,48.16,48.65,50.14,48.65,50.14Z"
            fill="#dcf97c"
          />
          <path
            d="M81.4,44.62A2.14,2.14,0,0,1,81.71,48l16.82-2.75a2,2,0,0,0-.6-3.31C92.41,42.64,81.4,44.62,81.4,44.62Z"
            fill="#dcf97c"
          />
          <path
            d="M70,19.86v9.76a4.59,4.59,0,0,0,2.62.52c.41,0,1.19-.21,1.59-.24v-10L72.09,0Z"
            fill="#d2ddef"
          />
          <path
            d="M105.23,107c2.61-.28,5.07-.48,7.33-.62a26.44,26.44,0,0,1-1.11-4.33c-2.4-14.9,0-33.65-3-41.92-.14-.37-.28-.74-.43-1.1-4.33,4.39-21.26,13.19-31.83,15.06-10,1.77-15.68,3.79-20.76,11.18-1.2,9.36-2.78,21.41.74,31.12a23.13,23.13,0,0,0,1.3,2.88C68.62,118.81,93.34,108.28,105.23,107Z"
            fill="#bdca31"
          />
          <path
            d="M104.57,42.74l-.07-.38a1.59,1.59,0,0,0-1.85-1.18l-.13,0,.06.2.07.38a1.48,1.48,0,0,1-1.28,1.7L39.16,53.81a1.61,1.61,0,0,0,1.79,1l62.34-10.35A1.48,1.48,0,0,0,104.57,42.74Z"
            fill="#b0dff6"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M72.09,0l-.45,4.27,1.51,14.25.21,10.39a13.56,13.56,0,0,1-1.77.05A8,8,0,0,1,70,28.7v.92a4.59,4.59,0,0,0,2.62.52c.41,0,1.19-.21,1.59-.24v-10Z"
            fill="#bfd0ee"
          />
          <path
            d="M74.4,29.32c0,.48-1,.88-2.29.88s-2.29-.4-2.29-.88"
            fill="none"
            stroke="#d2ddef"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g>
            <rect
              x="84.85"
              y="73.84"
              width="11.28"
              height="5.54"
              fill="#63aaae"
            />
            <polygon
              points="84.93 78.99 77.68 88.63 73.88 85.06 81.13 75.42 84.93 78.99"
              fill="#63aaae"
            />
            <polygon
              points="77.6 87.85 79.56 100.24 74.67 101.2 72.71 88.81 77.6 87.85"
              fill="#63aaae"
            />
            <polygon
              points="79.74 99.15 89.5 105.44 87.02 110.25 77.25 103.95 79.74 99.15"
              fill="#63aaae"
            />
            <polygon
              points="88.79 105.34 99.38 101.03 101.08 106.25 90.49 110.55 88.79 105.34"
              fill="#63aaae"
            />
            <polygon
              points="98.45 101.17 102.31 89.35 106.97 91.25 103.12 103.07 98.45 101.17"
              fill="#63aaae"
            />
            <polygon
              points="102.19 89.7 95.81 79.33 99.9 76.19 106.29 86.56 102.19 89.7"
              fill="#63aaae"
            />
            <path
              d="M103.25,89.73c0-.25-.06-.5-.11-.75a15.49,15.49,0,0,0-6.39-10.37l-.62-.39a12.53,12.53,0,0,0-11.28-.89,11.29,11.29,0,0,0-1.11.53,15,15,0,0,0-7.33,9.56c-.07.23-.12.46-.17.7a16.89,16.89,0,0,0,2.06,12.37c.13.22.27.43.42.64a13.37,13.37,0,0,0,10,5.93q.35,0,.69,0h.25a13.13,13.13,0,0,0,10.14-5l.26-.33a16.33,16.33,0,0,0,3.36-10A16.86,16.86,0,0,0,103.25,89.73Zm-5.24,2c0,5.17-3.76,9.37-8.4,9.37s-8.4-4.2-8.4-9.37,3.76-9.37,8.4-9.37S98,86.57,98,91.75Z"
              fill="#63aaae"
            />
          </g>
          <g>
            <rect
              x="66.29"
              y="61.78"
              width="5.27"
              height="2.59"
              fill="#63aaae"
            />
            <polygon
              points="66.33 64.19 62.94 68.69 61.16 67.03 64.55 62.52 66.33 64.19"
              fill="#63aaae"
            />
            <polygon
              points="62.9 68.33 63.82 74.12 61.53 74.57 60.62 68.78 62.9 68.33"
              fill="#63aaae"
            />
            <polygon
              points="63.9 73.61 68.47 76.56 67.31 78.8 62.74 75.86 63.9 73.61"
              fill="#63aaae"
            />
            <polygon
              points="68.13 76.51 73.08 74.49 73.88 76.93 68.93 78.94 68.13 76.51"
              fill="#63aaae"
            />
            <polygon
              points="72.65 74.56 74.45 69.03 76.63 69.92 74.83 75.45 72.65 74.56"
              fill="#63aaae"
            />
            <polygon
              points="74.4 69.19 71.41 64.35 73.33 62.88 76.31 67.73 74.4 69.19"
              fill="#63aaae"
            />
            <path
              d="M74.89,69.21a2.11,2.11,0,0,0,0-.35,7.17,7.17,0,0,0-.64-2.06,6.89,6.89,0,0,0-1.92-2.46,3.19,3.19,0,0,0-.43-.32l-.28-.19A6,6,0,0,0,70,63.18a5.57,5.57,0,0,0-1.48-.2,5.77,5.77,0,0,0-2.23.45,2.71,2.71,0,0,0-.52.24,7,7,0,0,0-3.43,4.46,1.94,1.94,0,0,0-.07.33,7.24,7.24,0,0,0-.19,1.69,7.66,7.66,0,0,0,1.15,4.09,1.81,1.81,0,0,0,.19.29,6.43,6.43,0,0,0,2.47,2.17h0a5.41,5.41,0,0,0,2.18.6h0a1.06,1.06,0,0,0,.31,0h.12a5.57,5.57,0,0,0,1.48-.2A5.81,5.81,0,0,0,72.28,76a6,6,0,0,0,1-1,.72.72,0,0,0,.11-.15,1.86,1.86,0,0,0,.21-.28,6.25,6.25,0,0,0,.62-1.06A7.74,7.74,0,0,0,75,70.15,7.3,7.3,0,0,0,74.89,69.21Zm-4.89,5a3.67,3.67,0,0,1-1.48.32,4.41,4.41,0,0,1,0-8.76,3.67,3.67,0,0,1,1.48.32,4.24,4.24,0,0,1,2.28,2.84,4.73,4.73,0,0,1,0,2.44A4.24,4.24,0,0,1,70,74.21Z"
              fill="#63aaae"
            />
          </g>
        </g>
        <g>
          <path
            d="M211.19,203.58a.8.8,0,0,0-.25-.5,1.22,1.22,0,0,0-.66-.2c-.64,0-1.3-.06-2-.07l-2,0c-.8,0-1.57,0-2.33.05l-2.11.11a1.34,1.34,0,0,0-.5.16.61.61,0,0,0-.28.42,2.81,2.81,0,0,0-.13.73c0,.28,0,.56,0,.83a1,1,0,0,0,.16.66.65.65,0,0,0,.5.16c.18,0,.5,0,.95,0s1-.07,1.6-.09c0,.63-.08,1.25-.1,1.86s0,1.22,0,1.83c0,.89,0,1.78.06,2.66s.1,1.78.19,2.67a.71.71,0,0,0,.31.59,1.33,1.33,0,0,0,.63.23l.22,0h.21c.27,0,.55,0,.84,0s.55-.05.82-.09a.79.79,0,0,0,.45-.2.61.61,0,0,0,.13-.44c0-.07,0-.27,0-.61s-.06-.75-.11-1.26-.07-1.1-.1-1.75,0-1.34,0-2.07c0-.57,0-1.13,0-1.69s0-1.12.1-1.67c.67,0,1.25,0,1.73.09a9.17,9.17,0,0,0,1.08.08.71.71,0,0,0,.45-.12.65.65,0,0,0,.19-.39,6,6,0,0,0,.11-1.11A7.11,7.11,0,0,0,211.19,203.58Z"
            fill="#fff"
          />
          <path
            d="M218.09,209.39a4.31,4.31,0,0,0-.73-1.34A4.23,4.23,0,0,0,216,207a4.54,4.54,0,0,0-2.08-.44,4.63,4.63,0,0,0-1.76.34,4.42,4.42,0,0,0-1.48.95,4.69,4.69,0,0,0-1,1.47,4.63,4.63,0,0,0-.38,1.87,4.38,4.38,0,0,0,.37,1.84,4.72,4.72,0,0,0,1,1.41,4.34,4.34,0,0,0,1.43.9,4.41,4.41,0,0,0,1.68.33,7.1,7.1,0,0,0,2.19-.32,3.64,3.64,0,0,0,1.5-.83.8.8,0,0,0,.29-.6v-.17a.81.81,0,0,0,0-.19c0-.13-.05-.26-.08-.39a2.91,2.91,0,0,0-.12-.39,1.05,1.05,0,0,0-.14-.3.26.26,0,0,0-.21-.09,1.32,1.32,0,0,0-.38.12,4.77,4.77,0,0,1-1.14.38,5.16,5.16,0,0,1-1.08.14,3,3,0,0,1-1.19-.24,2.59,2.59,0,0,1-.92-.65l1.49-.12c.52,0,1-.12,1.5-.19s.93-.15,1.36-.24a9.42,9.42,0,0,0,1.09-.31.63.63,0,0,0,.36-.28,1,1,0,0,0,.08-.4A3.87,3.87,0,0,0,218.09,209.39Zm-4.3.8c-.6.05-1.16.08-1.69.11a1.88,1.88,0,0,1,.73-1A2,2,0,0,1,214,209a1.72,1.72,0,0,1,.83.22,1.35,1.35,0,0,1,.62.74A11.09,11.09,0,0,1,213.79,210.19Z"
            fill="#fff"
          />
          <path
            d="M227.4,213.8a2.43,2.43,0,0,0-.09-.3c-.06-.15-.12-.3-.19-.44s-.14-.28-.22-.41-.27-.34-.42-.34a.57.57,0,0,0-.24.06l-.33.15a3,3,0,0,1-.4.19c-.15.07-.32.13-.49.19a3.41,3.41,0,0,1-.55.14,2.35,2.35,0,0,1-.51.06,2.16,2.16,0,0,1-.86-.17,2.06,2.06,0,0,1-.65-.46,1.84,1.84,0,0,1-.41-.67,2.12,2.12,0,0,1-.14-.79,1.86,1.86,0,0,1,.18-.82,2.16,2.16,0,0,1,.51-.65,2.75,2.75,0,0,1,.76-.46,3.52,3.52,0,0,1,.92-.21c0,.18,0,.36,0,.55s0,.35.06.52a.93.93,0,0,0,.8.84,5.39,5.39,0,0,0,1,.07.78.78,0,0,0,.51-.13,1,1,0,0,0,.21-.51,7.36,7.36,0,0,0,.1-1.25,4.43,4.43,0,0,0,0-.51c0-.17,0-.35-.05-.54a1.29,1.29,0,0,0-.23-.71,1.43,1.43,0,0,0-.59-.38,3.92,3.92,0,0,0-.91-.23,6.24,6.24,0,0,0-.85-.05,6.15,6.15,0,0,0-2,.34,5.94,5.94,0,0,0-1.74,1,4.83,4.83,0,0,0-1.23,1.47,3.85,3.85,0,0,0-.46,1.86,5.74,5.74,0,0,0,.06.76,4,4,0,0,0,.25.94,4.66,4.66,0,0,0,.52,1,3.4,3.4,0,0,0,.9.87,4.76,4.76,0,0,0,1.38.63,6.83,6.83,0,0,0,1.93.24,5.84,5.84,0,0,0,.93-.08,6.51,6.51,0,0,0,.92-.23,4.68,4.68,0,0,0,.82-.33,2.82,2.82,0,0,0,.64-.41.64.64,0,0,0,.25-.76Z"
            fill="#fff"
          />
          <path
            d="M237.11,207.67a2.17,2.17,0,0,0-.73-.77,2.69,2.69,0,0,0-.89-.34,5.61,5.61,0,0,0-.85-.08,5.3,5.3,0,0,0-1.53.23,4.27,4.27,0,0,0-1.15.53,1.82,1.82,0,0,0-.23.15c0-.12,0-.24,0-.37,0-.29,0-.6,0-.92s0-.88,0-1.28,0-.75,0-1.06,0-.52,0-.63a.74.74,0,0,0-.07-.36c-.05-.09-.17-.14-.36-.14l-.51,0-.61,0c-.2,0-.4,0-.59.06a3.21,3.21,0,0,0-.5.09.5.5,0,0,0-.41.36,4,4,0,0,0-.09.69,1.09,1.09,0,0,1,0,.18c0,.54,0,1.11-.07,1.69s0,1.29,0,1.94,0,1.35,0,2,0,1.28.07,1.88.06,1.15.11,1.66.07.94.11,1.31a1.37,1.37,0,0,0,.22.64,1.07,1.07,0,0,0,.73.25H231a1.39,1.39,0,0,0,.76-.2.56.56,0,0,0,.19-.46c0-.06,0-.12,0-.18l0-.2c-.06-.53-.1-1.2-.12-2s0-1.65-.06-2.57a3.57,3.57,0,0,1,1.91-.66.57.57,0,0,1,.51.26,1.26,1.26,0,0,1,.17.69c0,1.27,0,2.28-.1,3s-.1,1.21-.1,1.34a.7.7,0,0,0,.57.78,6.68,6.68,0,0,0,.84.14c.3,0,.53,0,.69,0,.31,0,.51-.08.6-.26a1.52,1.52,0,0,0,.17-.56c.07-.52.13-1,.19-1.58,0-.25,0-.49.07-.73s0-.55.05-.81c0-.5.06-1,.07-1.39s0-.8,0-1.12A2.77,2.77,0,0,0,237.11,207.67Z"
            fill="#fff"
          />
          <path
            d="M247.17,207.67a2.06,2.06,0,0,0-.72-.77,2.66,2.66,0,0,0-.9-.34,5.37,5.37,0,0,0-.84-.08,5.16,5.16,0,0,0-2.93.93c0-.1,0-.18,0-.26a1.62,1.62,0,0,0,0-.22.57.57,0,0,0-.09-.34.43.43,0,0,0-.36-.12h-.51l-.61.05-.59.06a3.21,3.21,0,0,0-.5.09.5.5,0,0,0-.41.36,3.27,3.27,0,0,0-.08.69c0,.22,0,.43,0,.64V209q0,1.4.09,2.79c0,.73.1,1.44.17,2.15h0l.06.6a1.27,1.27,0,0,0,.22.64,1,1,0,0,0,.72.25h1.16a1.42,1.42,0,0,0,.76-.2.59.59,0,0,0,.19-.46c0-.06,0-.12,0-.18l0-.2c-.07-.74-.13-1.49-.17-2.24s-.06-1.51-.06-2.28a3.94,3.94,0,0,1,1-.53,3.08,3.08,0,0,1,1-.17.59.59,0,0,1,.51.26,1.26,1.26,0,0,1,.17.69c0,.73,0,1.35,0,1.85s0,.92-.07,1.25-.06.59-.07.79,0,.36,0,.49a.7.7,0,0,0,.57.78,7,7,0,0,0,1.53.18c.31,0,.51-.08.6-.26a1.52,1.52,0,0,0,.17-.56c.07-.52.13-1,.19-1.58s.09-1.05.12-1.54,0-1,.07-1.39,0-.8,0-1.12A2.66,2.66,0,0,0,247.17,207.67Z"
            fill="#fff"
          />
          <path
            d="M257.33,209a3.82,3.82,0,0,0-2.18-1.36c0-.13,0-.22,0-.27a.76.76,0,0,0,0-.14c0-.19,0-.32-.13-.38a1.4,1.4,0,0,0-.37-.19,4.54,4.54,0,0,0-.68-.14,4.15,4.15,0,0,0-.67-.05,5.07,5.07,0,0,0-1.83.34,5.36,5.36,0,0,0-1.61,1,4.92,4.92,0,0,0-1.16,1.53,4.36,4.36,0,0,0-.44,2,4.7,4.7,0,0,0,.35,1.9,3.67,3.67,0,0,0,1,1.39,4.3,4.3,0,0,0,1.6.85,7.26,7.26,0,0,0,2.1.28,5.65,5.65,0,0,0,1.71-.27,5.16,5.16,0,0,0,1.52-.81,4.19,4.19,0,0,0,1.1-1.33,4.27,4.27,0,0,0-.38-4.3Zm-2.25,3.11a1.79,1.79,0,0,1-.47.52,2.24,2.24,0,0,1-.66.32,2.71,2.71,0,0,1-.74.11,2.55,2.55,0,0,1-.74-.11,1.92,1.92,0,0,1-.62-.32,1.51,1.51,0,0,1-.42-.52,1.64,1.64,0,0,1-.15-.71,2.19,2.19,0,0,1,.61-1.58,2.35,2.35,0,0,1,1.51-.72,1.63,1.63,0,0,0,0,.43.64.64,0,0,0,.13.26.73.73,0,0,0,.22.16,2.65,2.65,0,0,0,.35.13,1.74,1.74,0,0,1,.8.48,1.21,1.21,0,0,1,.31.84A1.41,1.41,0,0,1,255.08,212.11Z"
            fill="#fff"
          />
          <path
            d="M262.41,204.17c0-.29,0-.57,0-.84a.89.89,0,0,0-.12-.55.51.51,0,0,0-.4-.15,8.1,8.1,0,0,0-.9.06,5.67,5.67,0,0,0-1,.16.55.55,0,0,0-.37.26,2.16,2.16,0,0,0-.16.79c-.1,1-.17,2-.21,3s-.06,2.1-.06,3.11,0,1.76,0,2.54.05,1.43.1,2a1.18,1.18,0,0,0,.21.64,1,1,0,0,0,.72.25h1c.38,0,.61-.14.68-.31a2.21,2.21,0,0,0,.16-.73c0-.52.08-1.15.12-1.88s.07-1.51.09-2.35,0-1.7.06-2.57,0-1.73,0-2.55C262.42,204.75,262.42,204.45,262.41,204.17Z"
            fill="#fff"
          />
          <path
            d="M272.57,209a3.84,3.84,0,0,0-2.19-1.36c0-.13,0-.22.05-.27a.76.76,0,0,0,0-.14.44.44,0,0,0-.14-.38,1.32,1.32,0,0,0-.36-.19,4.42,4.42,0,0,0-.69-.14,4,4,0,0,0-.66-.05,5.07,5.07,0,0,0-1.83.34,5.54,5.54,0,0,0-1.62,1,4.89,4.89,0,0,0-1.15,1.53,4.36,4.36,0,0,0-.45,2,4.7,4.7,0,0,0,.36,1.9,3.65,3.65,0,0,0,1,1.39,4.35,4.35,0,0,0,1.61.85,7.26,7.26,0,0,0,2.1.28,5.54,5.54,0,0,0,1.7-.27,5.22,5.22,0,0,0,1.53-.81,4.16,4.16,0,0,0,1.09-1.33,4.23,4.23,0,0,0-.37-4.3Zm-2.26,3.11a1.66,1.66,0,0,1-.47.52,2.13,2.13,0,0,1-.66.32,2.65,2.65,0,0,1-.74.11,2.55,2.55,0,0,1-.74-.11,1.87,1.87,0,0,1-.61-.32,1.51,1.51,0,0,1-.42-.52,1.64,1.64,0,0,1-.15-.71,2.22,2.22,0,0,1,.6-1.58,2.37,2.37,0,0,1,1.52-.72,1.69,1.69,0,0,0,0,.43.65.65,0,0,0,.14.26.73.73,0,0,0,.22.16,2.2,2.2,0,0,0,.35.13,1.74,1.74,0,0,1,.8.48,1.2,1.2,0,0,1,.3.84A1.41,1.41,0,0,1,270.31,212.11Z"
            fill="#fff"
          />
          <path
            d="M283.62,208.88c0-.46,0-.85-.05-1.17a2.1,2.1,0,0,0-.08-.51.88.88,0,0,0-.17-.32.68.68,0,0,0-.27-.2l-.06,0a1.85,1.85,0,0,0-.31-.11,8.9,8.9,0,0,0-1-.19,5.93,5.93,0,0,0-.76-.07.42.42,0,0,0-.32.1.62.62,0,0,0-.13.36,4.3,4.3,0,0,0-.65-.15,4.62,4.62,0,0,0-.65,0,4.54,4.54,0,0,0-1.87.41,5.43,5.43,0,0,0-2.79,2.74,4.89,4.89,0,0,0-.44,2,4.1,4.1,0,0,0,.25,1.41,3.35,3.35,0,0,0,.72,1.14,3.55,3.55,0,0,0,1.15.76,4.18,4.18,0,0,0,1.54.27,4.34,4.34,0,0,0,2.69-.92c0,.44-.08.86-.13,1.27s-.1.8-.16,1.17a16.15,16.15,0,0,1-1.68-.12,8.2,8.2,0,0,1-1.65-.4,1.32,1.32,0,0,0-.45-.11.4.4,0,0,0-.26.1.93.93,0,0,0-.22.3c-.1.23-.21.5-.32.79a2.06,2.06,0,0,0-.16.68.6.6,0,0,0,.17.44,1.74,1.74,0,0,0,.42.3,11.81,11.81,0,0,0,2.06.68,10.47,10.47,0,0,0,2.27.22,3.4,3.4,0,0,0,1.08-.16l.19-.07a3.26,3.26,0,0,0,.67-.35,2.47,2.47,0,0,0,.62-.63,2,2,0,0,0,.31-.75q.12-.67.21-1.56c.06-.6.11-1.22.15-1.88s.06-1.31.08-2,0-1.33,0-1.94S283.64,209.34,283.62,208.88Zm-3,2.05c0,.34,0,.69,0,1a2.58,2.58,0,0,1-1.71.72,1.58,1.58,0,0,1-1.14-.39,1.31,1.31,0,0,1-.41-1,2.08,2.08,0,0,1,.15-.74,2.42,2.42,0,0,1,.44-.74,2.31,2.31,0,0,1,.7-.57,1.88,1.88,0,0,1,1-.23,3.2,3.2,0,0,1,.56,0,3,3,0,0,1,.48.13Z"
            fill="#fff"
          />
          <path
            d="M293.66,211.54q0-.85-.06-1.62c0-.51-.06-1-.09-1.41s-.07-.81-.1-1.13-.14-.55-.31-.64a1.66,1.66,0,0,0-.74-.13,3.65,3.65,0,0,0-.55,0l-.51.1a1.84,1.84,0,0,0-.73.34.74.74,0,0,0-.19.55c0,.07,0,.25,0,.54s.07.65.1,1.07.07.88.1,1.37.05.95.06,1.39a3.46,3.46,0,0,1-1,.51,3.31,3.31,0,0,1-1,.17.58.58,0,0,1-.51-.25,1.2,1.2,0,0,1-.17-.66c0-.46,0-.91,0-1.36s.07-.87.1-1.26.07-.72.1-1,0-.49,0-.61a.73.73,0,0,0-.57-.76,3.06,3.06,0,0,0-.56-.14,4,4,0,0,0-.6,0,2,2,0,0,0-.87.15.82.82,0,0,0-.36.65c-.07.51-.14,1-.19,1.53s-.1,1-.12,1.48-.06.92-.08,1.34,0,.78,0,1.08a2.64,2.64,0,0,0,.29,1.32,2.1,2.1,0,0,0,.72.73,2.58,2.58,0,0,0,.9.33,4.56,4.56,0,0,0,.85.08,5.17,5.17,0,0,0,1.56-.23,4.9,4.9,0,0,0,1.43-.71,18.79,18.79,0,0,1-.26,2.48c-.3,0-.57,0-.82,0s-.5-.05-.74-.09a6.69,6.69,0,0,1-.75-.16c-.26-.06-.53-.14-.83-.24l-.25-.07a.79.79,0,0,0-.2,0,.36.36,0,0,0-.25.1,2.27,2.27,0,0,0-.43.69,4.22,4.22,0,0,0-.18.45c-.05.15-.1.29-.13.41a1.08,1.08,0,0,0-.06.28.59.59,0,0,0,.16.4,1.5,1.5,0,0,0,.4.28,10,10,0,0,0,4.36.9,3.4,3.4,0,0,0,1.08-.16,2.93,2.93,0,0,0,.85-.42,2,2,0,0,0,.58-.63,1.74,1.74,0,0,0,.27-.75c.08-.64.14-1.35.17-2.13s.05-1.57.05-2.38C293.68,212.67,293.67,212.1,293.66,211.54Z"
            fill="#fff"
          />
          <path
            d="M309.58,202.53a.71.71,0,0,0-.4-.29,6.73,6.73,0,0,0-1.85-.25.37.37,0,0,0-.33.15.64.64,0,0,0-.15.26l-.09.43-.65-.05c-.21,0-.42,0-.64,0a12,12,0,0,0-2.39.24,7.48,7.48,0,0,0-2.12.75,4.49,4.49,0,0,0-1.52,1.3,3.09,3.09,0,0,0-.58,1.88,2.75,2.75,0,0,0,.52,1.74,3.92,3.92,0,0,0,1.28,1.07,6.49,6.49,0,0,0,1.68.63c.6.14,1.16.26,1.67.35s.94.19,1.28.29.52.23.52.39a.65.65,0,0,1-.25.52,1.9,1.9,0,0,1-.65.35,5.31,5.31,0,0,1-.92.19,8.89,8.89,0,0,1-1,.06,7.67,7.67,0,0,1-.91,0l-.59-.08-.3-.07-.25,0a.34.34,0,0,0-.29.12.68.68,0,0,0-.14.31c0,.23-.06.46-.09.71s0,.5,0,.73v.34a2.53,2.53,0,0,0,0,.38.8.8,0,0,0,.18.3.79.79,0,0,0,.39.18,12.85,12.85,0,0,0,2.14.19,9.42,9.42,0,0,0,2.38-.28,5.9,5.9,0,0,0,1.9-.84,4.22,4.22,0,0,0,1.26-1.34,3.54,3.54,0,0,0,.47-1.81,3.1,3.1,0,0,0-.49-1.81,3.74,3.74,0,0,0-1.22-1.09,6,6,0,0,0-1.6-.6c-.57-.14-1.11-.26-1.59-.35a10.16,10.16,0,0,1-1.22-.31c-.33-.12-.49-.29-.49-.53a.58.58,0,0,1,.2-.43,1.65,1.65,0,0,1,.56-.32,4.36,4.36,0,0,1,.84-.19,6.79,6.79,0,0,1,1-.08l.65,0c.22,0,.45,0,.69.07l0,.43c0,.14,0,.29,0,.43a.82.82,0,0,0,.11.39.41.41,0,0,0,.3.23,6.91,6.91,0,0,0,.8.15q.36,0,.93,0a.57.57,0,0,0,.47-.17.71.71,0,0,0,.19-.4c.05-.3.1-.59.14-.87s.09-.58.13-.89.06-.62.09-1,0-.74.07-1.17A.62.62,0,0,0,309.58,202.53Z"
            fill="#fff"
          />
          <path
            d="M319.17,211.12a1.13,1.13,0,0,0-.87-.54l-.39-.05-.41,0-.44,0-.47.05c.39-.34.8-.71,1.21-1.1a11.39,11.39,0,0,0,1-1,1.1,1.1,0,0,0,.31-.65,1,1,0,0,0-.25-.57,4.53,4.53,0,0,0-1.13-.94.74.74,0,0,0-.44-.14.55.55,0,0,0-.34.1,2.44,2.44,0,0,0-.3.27,19.25,19.25,0,0,0-1.46,1.66c-.45.58-.91,1.21-1.36,1.89,0-2.14,0-3.77.05-4.89s.06-1.79.06-2a.88.88,0,0,0-.07-.36c-.05-.09-.17-.14-.36-.14l-.52,0-.6,0c-.21,0-.4,0-.59.06a3,3,0,0,0-.5.09.53.53,0,0,0-.39.28,2.94,2.94,0,0,0-.11.77c-.05.57-.08,1.18-.1,1.82s0,1.29,0,1.94,0,1.35,0,2,0,1.3.07,1.9.07,1.17.11,1.68.08.95.12,1.32a1.27,1.27,0,0,0,.22.64,1,1,0,0,0,.72.25h1.16a1.42,1.42,0,0,0,.76-.2.59.59,0,0,0,.18-.46s0-.12,0-.26,0-.3,0-.49,0-.4-.05-.62,0-.46,0-.68a3.82,3.82,0,0,1,.67-.15,5.34,5.34,0,0,1,.69-.05,4.72,4.72,0,0,1,.68.05l.51.08a8.18,8.18,0,0,1-.05.88,5,5,0,0,1-.15.72q0,.16-.06.24c0,.06,0,.1,0,.14a.52.52,0,0,0,.14.38.61.61,0,0,0,.27.17,8.08,8.08,0,0,0,.92.21,4.93,4.93,0,0,0,.81.07.61.61,0,0,0,.52-.19,1.94,1.94,0,0,0,.25-.63c.08-.33.15-.72.22-1.16a7.41,7.41,0,0,0,.1-1.12A2.6,2.6,0,0,0,319.17,211.12Z"
            fill="#fff"
          />
          <path
            d="M324,203.4a1.11,1.11,0,0,0-.32-.56,1.18,1.18,0,0,0-.57-.28,4.89,4.89,0,0,0-.84-.07,1.84,1.84,0,0,0-1.37.42,1.77,1.77,0,0,0-.4,1.28,3.26,3.26,0,0,0,.09.84,1.27,1.27,0,0,0,.29.54,1.15,1.15,0,0,0,.55.28,3.85,3.85,0,0,0,.84.08,3.33,3.33,0,0,0,.91-.11,1.19,1.19,0,0,0,.56-.34,1.08,1.08,0,0,0,.28-.5,2.61,2.61,0,0,0,.08-.64A3.46,3.46,0,0,0,324,203.4Zm-.28,3.5q-.06-.14-.33-.15l-.29,0h-.3l-.76,0a4.26,4.26,0,0,0-.68.1.48.48,0,0,0-.45.33,2.92,2.92,0,0,0-.11.68c0,.7-.08,1.39-.1,2s0,1.34,0,2c0,.41,0,.83,0,1.25s0,.85.05,1.28a1.53,1.53,0,0,0,.19.67,1,1,0,0,0,.7.27,7.94,7.94,0,0,0,1,.05,1.78,1.78,0,0,0,.52-.05.53.53,0,0,0,.28-.17.68.68,0,0,0,.12-.3c0-.13,0-.28.05-.46.08-1.18.14-2.33.16-3.44s.05-2.3.05-3.58A1.67,1.67,0,0,0,323.75,206.9Z"
            fill="#fff"
          />
          <path
            d="M328.59,204.17v-.84a.37.37,0,0,0,0-.11.75.75,0,0,0-.12-.44.47.47,0,0,0-.39-.15,8.42,8.42,0,0,0-.91.06l-.31,0h0a4.88,4.88,0,0,0-.62.12.57.57,0,0,0-.38.26,2.41,2.41,0,0,0-.16.79c-.09,1-.16,2-.2,3s-.07,2.1-.07,3.11,0,1.76,0,2.54.06,1.43.11,2a1.18,1.18,0,0,0,.2.64,1,1,0,0,0,.72.25h1c.38,0,.61-.14.69-.31a2,2,0,0,0,.15-.73c.05-.52.09-1.15.13-1.88s.06-1.51.08-2.35.05-1.7.07-2.57,0-1.73,0-2.55C328.6,204.75,328.6,204.45,328.59,204.17Z"
            fill="#fff"
          />
          <path
            d="M333.3,204.55c0-.13,0-.26,0-.38,0-.29,0-.57,0-.84a.89.89,0,0,0-.12-.55.51.51,0,0,0-.4-.15,8.1,8.1,0,0,0-.9.06,5.67,5.67,0,0,0-.95.16.55.55,0,0,0-.37.26,1.42,1.42,0,0,0-.14.63.78.78,0,0,0,0,.16c-.1,1-.17,2-.21,3s-.06,2.1-.06,3.11,0,1.76,0,2.54.06,1.43.11,2a1.1,1.1,0,0,0,.21.64,1,1,0,0,0,.72.25h1c.38,0,.61-.14.68-.31a2.21,2.21,0,0,0,.16-.73c0-.52.08-1.15.12-1.88s.07-1.51.09-2.35,0-1.7.06-2.57,0-1.73,0-2.55C333.31,204.89,333.31,204.72,333.3,204.55Z"
            fill="#fff"
          />
          <path
            d="M339.06,209.58a.78.78,0,0,0,.45.2,5.55,5.55,0,0,0,1.07.11.64.64,0,0,0,.49-.15,1.27,1.27,0,0,0,.22-.42,8.29,8.29,0,0,0,.17-.82,5.73,5.73,0,0,0,.08-.86.83.83,0,0,0-.15-.54.86.86,0,0,0-.44-.28,6.81,6.81,0,0,0-1.22-.3,8.37,8.37,0,0,0-1.31-.11,5.36,5.36,0,0,0-1.49.21,4.38,4.38,0,0,0-1.28.57,3.09,3.09,0,0,0-.91.89,2.08,2.08,0,0,0-.34,1.17,2.3,2.3,0,0,0,.27,1.15,2.79,2.79,0,0,0,.69.8,4.27,4.27,0,0,0,.89.55l.89.39a5.63,5.63,0,0,1,.69.33q.27.17.27.36a.34.34,0,0,1-.25.34,2,2,0,0,1-.66.08,3.1,3.1,0,0,1-.63-.07,2.5,2.5,0,0,1-.7-.23,1.64,1.64,0,0,0-.47-.14c-.13,0-.25.12-.37.37s-.13.33-.22.53a4.89,4.89,0,0,0-.21.54,1.42,1.42,0,0,0,0,.38.62.62,0,0,0,.48.59,5.87,5.87,0,0,0,1.13.31,9.07,9.07,0,0,0,1.35.1,6.53,6.53,0,0,0,1.56-.19,4,4,0,0,0,1.24-.54,2.71,2.71,0,0,0,.83-.82,2.05,2.05,0,0,0,.3-1.09,2.18,2.18,0,0,0-.3-1.18,2.83,2.83,0,0,0-.77-.81,5,5,0,0,0-1-.55c-.36-.15-.69-.28-1-.39s-.57-.23-.77-.33-.3-.23-.3-.36a.44.44,0,0,1,.31-.43,2.21,2.21,0,0,1,.78-.12,2.5,2.5,0,0,1,.57.09V209A1,1,0,0,0,339.06,209.58Z"
            fill="#fff"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(120, 35)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default TechnologySkillsLink;
